<template>
  <div class="headerBox" :class="[position ? 'positionHead' : '']">
    <div class="leftMenu">
      <el-dropdown trigger="click" @command="otherClick">
        <span class="el-dropdown-link">
          <img src="../../assets/webImg/moreMenu.png" alt="" />
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            v-for="(item, index) in otherList"
            :icon="item.icon"
            :key="index"
            :command="item.command"
            >{{ item.title }}</el-dropdown-item
          >
        </el-dropdown-menu>
      </el-dropdown>
      <p>MasterSol</p>
    </div>
    <div class="rightUser">
      <div v-if="!token" class="loginBox" @click="openvisible">
        <p>Acceso</p>
        <img src="../../assets/webImg/loginImg.png" alt="" />
      </div>
      <el-dropdown trigger="click" @command="myInfoClick" v-else>
        <span class="el-dropdown-link">
          <img src="../../assets/webImg/userIcon.png" alt="" />
          <p>{{ userName }}</p>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            v-for="(item, index) in myInfoList"
            :icon="item.icon"
            :key="index"
            :command="item.command"
            >{{ item.title }}</el-dropdown-item
          >
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { outLogin, getInfor } from "../../utils/api/h5page";
import storage from "../../utils/storage";
export default {
  name: "",
  components: {},
  props: {
    position: {
      type: Boolean,
    },
  },
  data() {
    return {
      token: null,
      userInfo: {},
      userName: "",
      myInfoList: [
        {
          title: "Historial de pedidos",
          icon: "el-icon-tickets",
          command: 1,
        },
        {
          title: "Mi mensaje aquí",
          icon: "el-icon-s-custom",
          command: 2,
        },
        {
          title: "Salir del login",
          icon: "el-icon-switch-button",
          command: 3,
        },
      ],

      otherList: [
        {
          title: "Home",
          command: "/homeWeb",
        },
        {
          title: "Ventajas del préstamo MasterSol",
          command: "#first",
        },
        {
          title: "REQUISITOS",
          command: "#second",
        },
        {
          title: "Pasos para solicitar",
          command: "#third",
        },
        {
          title: "Información sobre nosotros",
          command: "#fourth",
        },
        {
          title: "Contáctenos",
          command: "#last",
        },
        {
          title: "FAQ",
          command: "https://www.mastersol.tech/h5/FAQ.html",
        },
        {
          title: "Política de Privacidad",
          command: "https://www.mastersol.tech/h5/privacidad.html",
        },
        {
          title: "Protocolo de usuario",
          command: "https://www.mastersol.tech/h5/use.html",
        },
      ],
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.setToken();
  },
  methods: {
    openvisible() {
      this.$emit("openVisible");
    },
    setToken() {
      this.token = localStorage.getItem("token");
      this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
      this.userName = localStorage.getItem("loginUser");
    },
    // 操作跳转我的信息列表
    myInfoClick(val) {
      console.log(val);
      switch (val) {
        case 1:
          this.$router.push('/historyListWeb');
          break;
        case 2:
          // 获取用户订单信息
          getInfor().then(({ data }) => {
            const { order_status } = data.data.loan_info;
            if (
              (order_status !== 0) &
              (order_status !== 3) &
              (order_status !== 8) &
              (order_status !== 10)
            ) {
              return this.$Toast(
                "Su estado actual: los datos no se pueden corregir"
              );
            } else {
              this.$router.push("/registerInfoWeb");
            }
          });
          break;
        case 3:
          outLogin().then(({ data }) => {
            this.$store.commit("LoginOut");
            storage.localStorageClearByLoginOut();
            this.$router.push("/homeWeb");
            window.location.reload();
          });
          break;
      }
    },

    otherClick(val) {
      if (this.$route.path == val) return;
      if (val.includes("#") && document.querySelector(val)) {
        document.querySelector(val).scrollIntoView();
      } else if (val.includes("#") && !document.querySelector(val)) {
        this.$router.push("/homeWeb");
        setTimeout(() => {
          document.querySelector(val).scrollIntoView();
        }, 0);
      } else if (val == "/homeWeb") {
        this.$router.push("/homeWeb");
      } else {
        // window.location.href = val;
        window.open(val);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.headerBox {
  margin: 0 auto;
  width: 12rem;
  height: 0.9rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .leftMenu,
  .rightUser {
    display: flex;
    align-items: center;
  }
  .leftMenu {
    p {
      font-family: Roboto, Roboto;
      font-weight: 700;
      font-size: 0.24rem;
      color: #333333;
    }
    img {
      cursor: pointer;
      width: 0.32rem;
      height: 0.32rem;
      margin-right: 0.15rem;
    }
  }
  .rightUser {
    & > div {
      height: 100%;
    }
    .loginBox {
      cursor: pointer;
      display: flex;
      align-items: center;
      width: 1.68rem;
      height: 0.54rem;
      background: #c90000;
      border-radius: 0.27rem;
      img {
        width: 0.46rem;
        height: 0.46rem;
      }
      p {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 0.25rem;
        color: #ffffff;
        margin: 0 0.13rem 0 0.2rem;
      }
    }
    .el-dropdown-link {
      cursor: pointer;
      display: flex;
      align-items: center;
      img {
        width: 0.54rem;
      }
      p {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 0.2rem;
        color: #333333;
        margin-left: 0.2rem;
      }
    }
  }
}

.positionHead {
  position: absolute;
  z-index: 10;
  left: 50%;
  transform: translateX(-50%);
}
</style>
